import { ITEM_STATUS } from "@/components/forecasts/constants";

export default class ItemValidator {
    static isDisabled(item) {
        return item.status !== ITEM_STATUS.ACTIVE;
    }

    static isCancelled(item) {
        return item.status === ITEM_STATUS.CANCELLED;
    }

    static isObsolete(item) {
        return item.status === ITEM_STATUS.OBSOLETE;
    }
}



// WEBPACK FOOTER //
// ./src/components/forecasts/validation/itemValidator.js